/* eslint-disable jsx-a11y/no-redundant-roles */
import PeCard from '@pe-libs/react-components/build/components/PeCard';
import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import useIntlNumber from '@pe-libs/react-components/build/lib/intl/hooks/useIntlNumber';
import React, { FC } from 'react';
import { InferType } from 'yup';
import Link from '#modules/expertDirectory/components/Link';
import { singleResultSchema } from '#modules/expertDirectory/schemas/searchDirectory';
import classNames from '#utils/classNames';
import ContactDetails from './ContactDetails';
import Details from './Details';
import IndustryField from './IndustryField';
import Labels from './Labels';
import messages from './messages';
import useStyles from './styles';

type SingleItemListProps = {
  data: InferType<typeof singleResultSchema>;
  counter: number;
};

const SingleItemList: FC<SingleItemListProps> = ({
  data: {
    ratings,
    profile: { title, activities, avatar, offer: offers, scenario, url, email },
    industries,
    address,
    websitesWithLabel,
    websites,
  },
  counter,
}) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const formatNumber = useIntlNumber();

  return (
    <li className={styles.singleBoxContainer} data-testid="single-item-list">
      <PeCard>
        <div className={styles.singleBoxContentContainer}>
          <div className={styles.counterAndIndustryContainer}>
            <div
              className={classNames(styles.counter, {
                [styles.counterMinWidth]: counter < 10,
              })}
            >
              {formatNumber(counter, { minimumFractionDigits: 0 })}
            </div>
            <IndustryField industryField={industries?.[0] as string} />
          </div>
          <Link href={url as string} title={formatMessage(messages.hoverTitle, { title })}>
            <PeTypography variant="h5" className={styles.title}>
              {title}
            </PeTypography>
          </Link>
          <PeTypography variant="body1">{activities}</PeTypography>
          <Labels offers={offers as string[]} />
          <ContactDetails
            address={address}
            websiteAnchor={(websitesWithLabel?.[0]?.label ?? websites?.[0]) as string}
            websiteUrl={websitesWithLabel?.[0]?.url as string}
            email={email as string}
          />
          <Details
            ratings={ratings}
            avatar={avatar as string}
            url={url as string}
            scenario={scenario as string}
            title={title as string}
          />
        </div>
      </PeCard>
    </li>
  );
};

export default React.memo(SingleItemList);
